import {
  ConsultaSeguimentoPergunta09Model,
  ConsultaSeguimentoPergunta09TrazPraVoceEnum,
} from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-09/model-consultaSeguimentoPergunta09'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'
import { booleanToSimNaoEnum } from 'components/form'
import { MChatPerguntaEnum } from 'graphql/types.generated'

import { HISTORICO_MCHAT_CALCULATION_STATUS, splitHeaderAndPerguntas } from '../utils-HistoricoMchatRf'

interface HistoricoMChatRfPergunta09Model {
  header: MchatRfAplicacaoQueryModel
  exemplosTrazPraVoce: MchatRfAplicacaoQueryModel[]
  perguntaSoParaMostrar: MchatRfAplicacaoQueryModel | undefined
  model: ConsultaSeguimentoPergunta09Model
}

export const convertAplicacaoPergunta09 = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): HistoricoMChatRfPergunta09Model | null => {
  const { header, perguntas } = splitHeaderAndPerguntas(aplicacoes, MChatPerguntaEnum.PERGUNTA_09_01)
  const perguntaSoParaMostrar = perguntas.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_09_08)
  const exemplosTrazPraVoce = perguntas.filter((aplicacao) => aplicacao.pergunta !== MChatPerguntaEnum.PERGUNTA_09_08)
  if (header === undefined) return null

  return {
    header,
    exemplosTrazPraVoce,
    perguntaSoParaMostrar,
    model: {
      status: HISTORICO_MCHAT_CALCULATION_STATUS,
      PERGUNTA_09_HEADER: booleanToSimNaoEnum(header.stPassou),
      PERGUNTA_09_TRAZ_PRA_VOCE: convertAplicacoesToTrazPraVoce(perguntas),
      PERGUNTA_09_SO_PARA_MOSTRAR: booleanToSimNaoEnum(perguntaSoParaMostrar?.stPassou),
      OUTRO: convertAplicacaoToOutro(
        perguntas.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_09_07)
      ),
    },
  }
}

const convertAplicacoesToTrazPraVoce = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): Record<ConsultaSeguimentoPergunta09TrazPraVoceEnum, ReturnType<typeof booleanToSimNaoEnum>> =>
  aplicacoes.reduce<Record<ConsultaSeguimentoPergunta09TrazPraVoceEnum, ReturnType<typeof booleanToSimNaoEnum>>>(
    (acc, aplicacao) => {
      const pergunta = MAP_PERGUNTA_TO_ENUM[aplicacao.pergunta]

      if (pergunta) {
        acc[pergunta] = booleanToSimNaoEnum(aplicacao.stPassou)
      }

      return acc
    },
    { ...EMPTY_TRAZ_PRA_VOCE }
  )

const convertAplicacaoToOutro = (
  aplicacao: MchatRfAplicacaoQueryModel | undefined
): ConsultaSeguimentoPergunta09Model['OUTRO'] => ({
  radioValue: booleanToSimNaoEnum(aplicacao?.stPassou),
  textValue: aplicacao?.outros ?? undefined,
})

const EMPTY_TRAZ_PRA_VOCE: Record<ConsultaSeguimentoPergunta09TrazPraVoceEnum, undefined> = {
  [ConsultaSeguimentoPergunta09TrazPraVoceEnum.FIGURA_OU_BRINQUEDO]: undefined,
  [ConsultaSeguimentoPergunta09TrazPraVoceEnum.DESENHO_QUE_ELE_FEZ]: undefined,
  [ConsultaSeguimentoPergunta09TrazPraVoceEnum.FLOR_QUE_ELE_PEGOU]: undefined,
  [ConsultaSeguimentoPergunta09TrazPraVoceEnum.BICHINHO_QUE_ELE_ENCONTROU]: undefined,
  [ConsultaSeguimentoPergunta09TrazPraVoceEnum.PECAS_QUE_ELE_JUNTOU]: undefined,
}

const MAP_PERGUNTA_TO_ENUM: Partial<Record<MChatPerguntaEnum, ConsultaSeguimentoPergunta09TrazPraVoceEnum>> = {
  [MChatPerguntaEnum.PERGUNTA_09_02]: ConsultaSeguimentoPergunta09TrazPraVoceEnum.FIGURA_OU_BRINQUEDO,
  [MChatPerguntaEnum.PERGUNTA_09_03]: ConsultaSeguimentoPergunta09TrazPraVoceEnum.DESENHO_QUE_ELE_FEZ,
  [MChatPerguntaEnum.PERGUNTA_09_04]: ConsultaSeguimentoPergunta09TrazPraVoceEnum.FLOR_QUE_ELE_PEGOU,
  [MChatPerguntaEnum.PERGUNTA_09_05]: ConsultaSeguimentoPergunta09TrazPraVoceEnum.BICHINHO_QUE_ELE_ENCONTROU,
  [MChatPerguntaEnum.PERGUNTA_09_06]: ConsultaSeguimentoPergunta09TrazPraVoceEnum.PECAS_QUE_ELE_JUNTOU,
}
